module.exports = __webpack_public_path__ + "static/media/raspberry.a40eb61c.jpg";